/* template */
<template><div class="tip-card"><mpx-view v-for="(item, index) in (changeTicketTip)" @tap="toPurchaseNotice(index)" class="tips-item"><div class="tips-icon"></div><hl-text :text="(item)" :hlStyle="(index ? detailStyle : hlStyle)" class="tips-text"/></mpx-view></div></template>

/* styles */
<style scoped lang="stylus" mpxStyleOptions='{"mid":"m6fac6a8c"}'>
  @import '~@/mixins/stylus/color.styl'

  .tip-card
    margin-bottom 10px
    background #FFF4EE
    padding 10px
    box-sizing border-box
    border-radius 8px
    font-family PingFangSC-Regular
    font-size 12px
    font-weight normal
    line-height 18px
    letter-spacing 0px
    color #333333
    position relative
  .tips-item
    position relative
  .tips-icon
    position absolute
    width 2px
    height 2px
    background #222222
    border-radius 50%
    top 9px
    left 0
  .tips-text
    margin-left 4px
  // .detail
  //   color #FF6400
  //   position relative
  //   margin-top 2px
  //   line-height 18px
  //   &::after
  //     content ''
  //     top 6px
  //     right -8px
  //     position absolute
  //     width 4px
  //     height 4px
  //     border-top 1.5px solid
  //     border-right 1.5px solid
  //     transform rotate(45deg)
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m6fac6a8c"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./change-tip.mpx.js?isComponent&outputPath=components%2Fchange-tip6fac6a8c%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!./change-tip.mpx?ctorType=component&index=0&isComponent&mpx&outputPath=components%2Fchange-tip6fac6a8c%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m6fac6a8c"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/change-tip6fac6a8c/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {'es-icon':getComponent(require("../../../../node_modules/@didi/es-mpx-ui/lib/icon/index.mpx?isComponent&outputPath=components%2Findex6fe48a3a%2Findex")),'hl-text':getComponent(require("../../../components/hl-text/index.mpx?isComponent&outputPath=components%2Findex10de904a%2Findex")),'mpx-view':getComponent(require("@mpxjs/webpack-plugin/lib/runtime/components/web/mpx-view.vue?isComponent"), { __mpxBuiltIn: true })},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules)
  )
</script>
